module.exports = __webpack_public_path__ + "static/img/icon_group_3.0b79d91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2.0/icon_group_3.png
// module id = Tf5k
// module chunks = 0